import { render, staticRenderFns } from "./AreasEntrega.vue?vue&type=template&id=df8ed2e2&scoped=true&lang=pug"
import script from "./AreasEntrega.vue?vue&type=script&lang=js"
export * from "./AreasEntrega.vue?vue&type=script&lang=js"
import style0 from "./AreasEntrega.vue?vue&type=style&index=0&id=df8ed2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8ed2e2",
  null
  
)

export default component.exports